import {TypeFiltre} from './type-filtre';

export class EquipeGroupeDeTravailItem {
	typeFiltre: TypeFiltre;
	id: number;

	constructor(TypeFiltre: TypeFiltre, id: number) {
		this.typeFiltre = TypeFiltre;
		this.id = id;
	}
}
